module.exports = __webpack_public_path__ + "img/check-select.727b887b.svg";